import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const dashboards = ['Agency Dashboard', 'Medical Practice Dashboard', 'Construction Dashboard', 'CEO Dashboard', 'Marketing Dashboard', 'Operations Dashboard', 'Sales Dashboard', 'Financial Dashboard', 'Customer Success Dashboard'];
  return <section id="solutions" className="py-32 overflow-hidden" data-id="element-104">
      <div className="max-w-7xl mx-auto px-6 mb-16" data-id="element-105">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-106">
          Every dashboard should feel unique.
          <br data-id="element-107" />
          <span className="text-textSecondary" data-id="element-108">
            Not template-based. Premium.
          </span>
        </motion.h2>
      </div>

      {/* Infinite Carousel */}
      <div className="relative w-full flex overflow-x-hidden" data-id="element-109">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" data-id="element-110" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" data-id="element-111" />

        <motion.div animate={{
        x: ['0%', '-50%']
      }} transition={{
        ease: 'linear',
        duration: 40,
        repeat: Infinity
      }} className="flex gap-6 px-6 whitespace-nowrap" data-id="element-112">
          {[...dashboards, ...dashboards].map((name, i) => <div key={i} className="w-[400px] h-[250px] bg-card border border-white/5 rounded-2xl p-6 flex flex-col justify-between group hover:border-white/20 transition-colors" data-id="element-113">
              <div className="flex items-center justify-between mb-4" data-id="element-114">
                <div className="text-sm font-medium text-textSecondary" data-id="element-115">
                  {name}
                </div>
                <div className="w-2 h-2 rounded-full bg-accent/50 group-hover:bg-accent transition-colors" data-id="element-116" />
              </div>

              {/* Abstract Dashboard Visual */}
              <div className="flex-1 grid grid-cols-3 gap-3 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-117">
                <div className="col-span-2 bg-secondary rounded-lg" data-id="element-118" />
                <div className="col-span-1 bg-secondary rounded-lg" data-id="element-119" />
                <div className="col-span-1 bg-secondary rounded-lg" data-id="element-120" />
                <div className="col-span-2 bg-secondary rounded-lg" data-id="element-121" />
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}